export const fixNumber = (num: number): String => {
  let arr = num.toString().split(".");

  if (arr.length === 1) {
    return `$${formatNumber(arr[0])}.00`;
  } else {
    const arr2 = arr[1].split("");
    if (arr[1].length === 1) return `$${formatNumber(arr[0])}.${arr[1]}0`;
    else return `$${formatNumber(arr[0])}.${arr2.slice(0, 2).join("")}`;
  }
};

const formatNumber = (num: string): String => {
  let str = "";
  const len = num.length;
  const arr = num.split("");
  arr.reverse();

  for (let i = 0; i < len; i++) {
    if (i > 0 && i % 3 === 0) str = `${arr[i]},${str}`;
    else str = arr[i] + str;
  }

  return str;
};

export const map = (
  value: number,
  istart: number,
  istop: number,
  ostart: number,
  ostop: number
) => {
  return ostart + (ostop - ostart) * ((value - istart) / (istop - istart));
};

export const clamp = (value: number, min: number, max: number): number => {
  if (value < min) return min;
  else if (value > max) return max;
  else return value;
};

export const calculateOds = (
  prizePool: number,
  rektPool: number,
  rake: number
): number => {
  return ((1 - rake) * prizePool) / rektPool;
};

export const formatTime = (time: number) => {
  if (time < 0 || time === null || time === undefined || isNaN(time)) {
    return `00:00`;
  }
  let min = Math.floor(time / 60).toString();
  if (min.length < 2) min = `0${min}`;

  let sec = (time % 60).toString();
  if (sec.length < 2) sec = `0${sec}`;

  return `${min}:${sec}`;
};

export const getRandomInt = (min: number, max: number) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
};

export const timer = (time: number) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(0);
    }, time);
  });
};

export const removeDupConfig = (arrayObj: any[], keyStr: string) => {
  return Object.values(
    arrayObj.reduce((result, item) => {
      const key = item[keyStr];
      result[key] = item;
      return result;
    }, {})
  );
};

export const handelFormatTitle = (title: string) => {
  if (!title) return title;
  const newTitle = `${title}`.toLocaleLowerCase() || "";
  return `${title[0].toUpperCase()}${newTitle.substring(1, newTitle.length)}`;
};

const durationMap = {
  // years: [1, 1],
  // months: [1, 1],
  // weeks: [1, 1],
  days: [1000 * 60 * 60 * 24, 1],
  hours: [1000 * 60 * 60, 24],
  minutes: [1000 * 60, 60],
  seconds: [1000, 60],
  // milliseconds: [1, 1000],
};

export const formatDuration = (fromTime: number, toTime: number) => {
  const difference = Math.abs(toTime - fromTime);

  const result = Object.entries(durationMap).map(([key, [val, mod]]) =>
    Math.floor((difference / val) % mod)
  );

  const nonZeroIdx = Math.min(
    result.findIndex((x) => x > 0),
    2
  );
  return result
    .slice(nonZeroIdx)
    .map((x) => `${x}`.padStart(2, "0"))
    .join(":");
};

export const calculateTimeLeft = (expiryDate: string, trimDays = true) => {
  let difference: number = (new Date(expiryDate) as any) - (new Date() as any);
  let timeLeft: any = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    duration: 0,
  };

  if (difference > 0) {
    timeLeft = {
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
      duration: Math.floor(difference / 1000),
    };

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    if (trimDays) {
      timeLeft.hours += days * 24;
    } else {
      timeLeft.days = days;
    }
  }

  return timeLeft;
};

export function formatCoin(num, decimal, min = decimal) {
  if (num === null || num === undefined || isNaN(num)) return 0;

  const numberFormat = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: min,
    maximumFractionDigits: decimal,
  });
  return numberFormat.format(+num);
}

export const renderPercent = (value: number) => {
  const newValueArr = `${value}`.split(".")[1] || "";
  return `${newValueArr}00`.slice(0, 2);
};

export const loadSavedStatte = (name, initialState) => {
  try {
    const savedState = JSON.parse(localStorage.getItem(name));
    return {
      ...initialState,
      ...savedState,
      assetType: "USDC",
    };
  } catch (err) {
    return initialState;
  }
};

export const getRound = (time: any) => {
  // const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const timeForTimeZone = new Date(time);
  const newValueTime = new Date(timeForTimeZone);
  const house = newValueTime.getHours();
  const minutes = newValueTime.getMinutes();
  let result = 0;
  if (house === 0 && minutes === 0) {
    return 1;
  }
  if (house === 0) {
    result = minutes;
  } else {
    result = house * 60;
    if (minutes > 0) {
      result += minutes;
    }
  }
  return result;
};

export const enterContest = async ({
  contestId,
  wager,
  token,
  cardType,
  subscriptionKey,
  assetType,
  moonOdds,
  rektOdds,
}: any) => {
  const response = await fetch(
    `${process.env.REACT_APP_URL_HXROAPI}/contestentry/add-contest-entry`,
    {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "X-Subscription-Key": subscriptionKey,
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        contestType: "OverUnder",
        direction: cardType,
        contestId,
        wager,
        assetType,
        moonOdds,
        rektOdds,
      }),
    }
  );
  const data = await response.json();
  if (!response.ok) {
    throw data;
  }
  return data;
};

export const getWinningStatus = (
  pricing: any,
  status: any,
  position: any,
  isSimulating: any,
  isCanceledRefund: any
) => {
  if (isCanceledRefund) {
    return "CXL-REFUND";
  }
  if (status === "Closed") {
    if (isSimulating) {
      return "Cancelled";
    }

    const livePrice = pricing?.[0]?.livePrice;
    const closePrice = pricing?.[0]?.closePrice;

    if (position === "moon") {
      if (livePrice?.blendedPrice > closePrice?.blendedPrice) {
        return "OutOfTheMoney";
      } else {
        return "InTheMoney";
      }
    } else if (position === "rekt") {
      if (livePrice?.blendedPrice > closePrice?.blendedPrice) {
        return "InTheMoney";
      } else {
        return "OutOfTheMoney";
      }
    } else {
      return "";
    }
  }
  return status;
};

export function formatNumberLockPrice(num, decimal, min = decimal) {
  if (num === null || num === undefined || isNaN(num)) return 0;

  const numberFormat = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: min,
    maximumFractionDigits: decimal,
  });
  return numberFormat.format(+num);
}

export const currentPool = (assetType, pool) => {
  switch (assetType) {
    case "BTC":
      return formatNumberLockPrice(pool * 100000000, 0);
    case "ETH":
      return formatNumberLockPrice(pool, 5);
    case "USDT":
      return formatNumberLockPrice(pool, 2);
    default:
      return formatNumberLockPrice(pool, 2);
  }
};

export function formatNumberForOdds(value: any, hadDecimal?: boolean) {
  if (!value) {
    return 0;
  }
  const valueNumber = Number(value);

  const numStr = Number(
    (Math.floor(valueNumber * 100) / 100).toString()
  ).toLocaleString("en-US");
  const decimalIndex = numStr.indexOf(".");

  if (decimalIndex === -1 && !hadDecimal) return numStr + ".00";
  if (decimalIndex === -1 && hadDecimal) return numStr;

  const decimalPart = numStr.substring(decimalIndex + 1);

  return decimalPart.length === 1 ? numStr + "0" : numStr;
}

export const activeEventFathom = (key: string) => {
  try {
   const fathom = (window as any).fathom;
   if (fathom) {
     fathom.trackEvent(key);
   }
  } catch (error) {
   console.log(error)
  }
 };